import { render, staticRenderFns } from "./AssetUnassign.vue?vue&type=template&id=de7c228e&scoped=true&"
import script from "./AssetUnassign.vue?vue&type=script&lang=js&"
export * from "./AssetUnassign.vue?vue&type=script&lang=js&"
import style0 from "./AssetUnassign.vue?vue&type=style&index=0&id=de7c228e&lang=scss&scoped=true&"
import style1 from "./AssetUnassign.vue?vue&type=style&index=1&id=de7c228e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7c228e",
  null
  
)

export default component.exports